import React from 'react'

const AppointmentDetailsModal = ({selectedEvent, onClose, onEdit}) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl"
                    aria-label="Close"
                >
                    ✕
                </button>

                {/* Header */}
                <h2 className="text-2xl font-semibold mb-6 text-center">Appointment Details</h2>

                {/* Details */}
                <div className="space-y-4 text-sm text-gray-700">
                    <div className="flex justify-between">
                        <span className="font-medium text-gray-500">Title:</span>
                        <span>{selectedEvent.event_title}</span>
                    </div>

                    <div className="flex justify-between">
                        <span className="font-medium text-gray-500">Type:</span>
                        <span>{selectedEvent.type}</span>
                    </div>

                    <div className="flex justify-between">
                        <span className="font-medium text-gray-500">Date:</span>
                        <span>{new Date(selectedEvent.date).toLocaleDateString()}</span>
                    </div>

                    <div className="flex justify-between">
                        <span className="font-medium text-gray-500">Time:</span>
                        <span>
                            {new Date(selectedEvent.start_time).toLocaleTimeString([], {
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: true,
                            })}
                            {selectedEvent.end_time &&
                                ` - ${new Date(selectedEvent.end_time).toLocaleTimeString([], {
                                    hour: 'numeric',
                                    minute: '2-digit',
                                    hour12: true,
                                })}`}
                        </span>
                    </div>


                    {selectedEvent.location && (
                        <div className="flex justify-between">
                            <span className="font-medium text-gray-500">Location:</span>
                            <span className="text-right">{selectedEvent.location}</span>
                        </div>
                    )}

                    {selectedEvent.reminder_interval && (
                        <div className="flex justify-between">
                            <span className="font-medium text-gray-500">Reminder:</span>
                            <span>
                                {selectedEvent.reminder_interval === 1440
                                    ? "1 day before"
                                    : selectedEvent.reminder_interval === 60
                                        ? "1 hour before"
                                        : `${selectedEvent.reminder_interval} minutes before`}
                            </span>
                        </div>
                    )}

                    {selectedEvent.notes && (
                        <div>
                            <div className="font-medium text-gray-500 mb-1">Notes:</div>
                            <p className="bg-gray-100 p-2 rounded text-sm text-gray-800 whitespace-pre-wrap">
                                {selectedEvent.notes}
                            </p>
                        </div>
                    )}
                </div>

                {/* Edit Button */}
                <button
                    onClick={onEdit}
                    className="mt-6 w-full py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition"
                >
                    Edit Appointment
                </button>
            </div>
        </div>
    )
}

export default AppointmentDetailsModal